import React from "react";

import { Form, Select, Collapse, Button, Table, Space, Input } from "antd";
import Highlighter from "react-highlight-words";
import { SearchOutlined } from "@ant-design/icons";
import ExportCSV from "../../Common/ExportCSV";
import moment from "moment";

const { Option } = Select;
const { Panel } = Collapse;

class TableOne extends React.Component {
  state = {
    searchText: "",
    searchedColumn: "",
    tableOneData: this.props.tableOneData,
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90, paddingLeft: "5px", paddingRight: "5px" }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters, confirm)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters, confirm) => {
    clearFilters();
    confirm();
    this.setState({ searchText: "" });
  };

  render() {
    const { formOneOnFinish, hmgMainGetData, hmgGetData, hotelGetData } =
      this.props;

    const columns = [
      {
        title: "User Name",
        dataIndex: "user_name",
        key: "user_name",
        width: "200px",
        ...this.getColumnSearchProps("user_name"),
        fixed: "left",
        sorter: (a, b) =>
          a.user_name ? a.user_name.localeCompare(b.user_name) : null,
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: "200px",
        ...this.getColumnSearchProps("name"),
        sorter: (a, b) => (a.name ? a.name.localeCompare(b.name) : null),
      },
      {
        title: "Email",
        dataIndex: "email",
        key: "email",
        width: "200px",
        ...this.getColumnSearchProps("email"),
        sorter: (a, b) => (a.email ? a.email.localeCompare(b.email) : null),
      },
      {
        title: "Date",
        dataIndex: "date",
        key: "date",
        width: "200px",
        ...this.getColumnSearchProps("date"),
        render: (text, record) => (
          <span>
            {text ? moment(text).local().format("YYYY-MM-DD HH:mm:ss") : null}
          </span>
        ),
        sorter: (a, b) => (a.date ? a.date.localeCompare(b.date) : null),
      },
      // {
      //   title: 'app',
      //   dataIndex: 'app',
      //   key: 'app',
      //   width: '200px',
      //   ...this.getColumnSearchProps('app'),
      //   sorter: (a, b) => a.app ? a.app.localeCompare(b.app) : null
      // },
      {
        title: "App Type",
        dataIndex: "page",
        key: "page",
        width: "200px",
        ...this.getColumnSearchProps("page"),
        sorter: (a, b) => (a.page ? a.page.localeCompare(b.page) : null),
      },
      {
        title: "App",
        dataIndex: "message",
        key: "message",
        width: "200px",
        ...this.getColumnSearchProps("message"),
        sorter: (a, b) =>
          a.message ? a.message.localeCompare(b.message) : null,
      },
    ];

    return (
      <div>
        <Collapse defaultActiveKey={["3_1"]} expandIconPosition="end">
          <Panel header="User Statistics" key="3_1">
            <div className="is_table_3">
              <ExportCSV
                csvData={this.props.tableOneData}
                fileName={"UserStatistics"}
                columnNames={columns}
              />
              <Table
                columns={columns}
                dataSource={this.props.tableOneData}
                size="small"
                rowKey="_id"
                scroll={{ x: 1500 }}
              />
              <div>
                {this.props.tableOneData &&
                this.props.tableOneData.length > 0 ? (
                  <div>Total : {this.props.tableOneData.length} </div>
                ) : null}
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>
    );
  }
}

export default TableOne;
